import { useEffect, useState } from "react";

import { useCurrentUser } from "@hooks/queries";
import container from "@src/container";

export const TrackingServiceWrapper = ({
  children,
  trackerId,
  collectorUrl,
  growthbookTrackerId,
  growthbookCollectorUrl,
}) => {
  const { snowplowTrackingService, xApiTrackingService } = container;
  const user = useCurrentUser();

  const [snowplowInitialized, setSnowplowInitialized] = useState(false);
  const [xApiInitialized, setXApiInitialized] = useState(false);

  if (!snowplowInitialized) {
    snowplowTrackingService.configure({
      trackerId,
      collectorUrl,
      user,
      growthbookTrackerId,
      growthbookCollectorUrl,
    });
    setSnowplowInitialized(true);
  }

  if (!xApiInitialized) {
    xApiTrackingService.configure(user);
    setXApiInitialized(true);
  }

  useEffect(() => {
    // Resets the tracking services
    // when the user changes or is set
    snowplowTrackingService.setUser(user);
    xApiTrackingService.configure(user);
  }, [user]);

  return children;
};
